import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=601dd29d&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=601dd29d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601dd29d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('601dd29d')) {
      api.createRecord('601dd29d', component.options)
    } else {
      api.reload('601dd29d', component.options)
    }
    module.hot.accept("./DashboardLayout.vue?vue&type=template&id=601dd29d&scoped=true&", function () {
      api.rerender('601dd29d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/DashboardLayout.vue"
export default component.exports